<template>
  <div>
    <v-card
      class="common-card-log d-flex justify-center text-center mx-auto info-card"
    >
      <v-row class="d-flex justify-center">
        <v-col class="d-flex justify-center flex-column">
          <v-text-field
            outlined
            dense
            label="نام و نام‌خانوادگی"
            v-model="name"
            type="text"
          >
          </v-text-field>
          <v-text-field
            outlined
            dense
            label="موبایل"
            v-model="mobile"
            type="number"
            hide-details
          >
          </v-text-field>
          <span
            class="red--text text-right mb-3 pt-0 mt-0"
            v-if="mobile && !validateMobileNumber(mobile)"
            >شماره موبایل وارد شده صحیح نمی‌باشد.</span
          >
          <v-text-field
            outlined
            dense
            label="ایمیل"
            v-model="email"
            type="email"
            hide-details
            :class="mobile && !validateMobileNumber(mobile) ? '' : 'mt-6'"
          >
          </v-text-field>
          <span
            class="red--text text-right"
            v-if="email != '-' && !validateEmail(email)"
            >ایمیل وارد شده صحیح نمی‌باشد.</span
          >
          <v-row
            class="text-right mt-4 justify-between flex-column flex-sm-row"
          >
            <v-col>
              <v-icon v-if="!rules" class="primary--text" @click="rules = true">
                mdi-checkbox-blank-outline
              </v-icon>
              <v-icon v-if="rules" class="primary--text" @click="rules = false">
                mdi-checkbox-marked-outline
              </v-icon>
              <span
                class="primary--text "
                @click="rulesDialog = true"
                style="cursor: pointer"
              >
                شرایط و قوانین را می‌پذیرم.
              </span>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-btn
                class="primary white--text"
                :disabled="submitDisable"
                @click="entrance()"
              >
                ورود
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="rulesDialog" width="370">
      <v-card class="rules-card">
        <div class="line-modal-rules">
          <v-col xl="8" lg="8" md="8" sm="8" xs="8" class="p-0">
            <h4 class="c-grey fs-small font-weight-bold my-0">قوانین و مقررات</h4>
          </v-col>
          <v-col xl="4" lg="4" md="4" sm="4" xs="4" class="p-0" align="end">
            <span class="pointer fs-medium" @click="rulesDialog = false"
              ><v-icon>$Close</v-icon></span
            >
          </v-col>
        </div>

        <hr class="mt-2 mb-8" />
        <v-card-text>
          <span>
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
            استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و
            کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی
            در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را
            می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی
            الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این
            صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و
            شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای
            اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد
            استفاده قرار گیرد.
          </span>
        </v-card-text>

<!--        <div class="footer-modals">-->
<!--          <v-icon-->
<!--            v-if="!rules"-->
<!--            class="primary&#45;&#45;text"-->
<!--            @click="-->
<!--              rules = true;-->
<!--              rulesDialog = false;-->
<!--            "-->
<!--          >-->
<!--            mdi-checkbox-blank-outline-->
<!--          </v-icon>-->
<!--          <v-icon-->
<!--            v-if="rules"-->
<!--            class="primary&#45;&#45;text"-->
<!--            @click="-->
<!--              rules = false;-->
<!--              rulesDialog = false;-->
<!--            "-->
<!--          >-->
<!--            mdi-checkbox-marked-outline-->
<!--          </v-icon>-->
<!--          <span class="primary&#45;&#45;text mr-2" @click="rulesDialog = false">-->
<!--            شرایط و قوانین را می‌پذیرم.-->
<!--          </span>-->
<!--        </div>-->
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from "axios";
export default {
  data() {
    return {
      name: "",
      mobile: "",
      email: "",
      rules: false,
      rulesDialog: false,
    };
  },
  methods: {
    validateMobileNumber(mobile) {
      const pattern = /^(?:\+98|0)?9\d{9}$/; // Regex pattern for Iranian mobile mobile
      return pattern.test(mobile);
    },
    entrance() {
      Axios.patch(
        this.baseUrl + "/onlineShop/user/edit",
        {
          name: this.name,
          mobile: this.mobile,
          email: this.email,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            localStorage.setItem("name", this.name);
            this.toast(res.data.message, "success");
            // this.entranceLoading = false;
            setTimeout(() => {
              this.$router.push("/");
            }, 300);
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          // this.entranceLoading = false;
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    // if (!localStorage.getItem("mobile")) {
    //   this.$router.push("/Page404");
    // }
    this.mobile = localStorage.getItem("mobile");
    // this.name =
    //   localStorage.getItem("name") == "کاربر جدید"
    //     ? ""
    //     : localStorage.getItem("name");
  },
  computed: {
    submitDisable() {
      if (this.name && this.mobile && this.email) {
        if (
          !this.rules ||
          !this.validateEmail(this.email) ||
          this.mobile.length < 10 ||
          this.name.length < 3
        )
          return true;
        else {
          return false;
        }
      }
      return true;
    },
  },
};
</script>
<style lang="scss">
.line-modal-rules {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.fields {
  width: 50%;
}
.footer-modals {
  display: flex;
  justify-content: flex-start;
}
.rules-card {
  border-radius: 15px !important;
  padding: 15px;
  max-height: 680px;
  overflow-y: auto;
  .custom-input {
    .v-textarea {
      .v-input__slot {
        height: 246px !important;
      }
    }
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__icon--append {
      padding-top: 3px !important;
      i {
        color: #7c4dff !important;
        cursor: pointer;
      }
    }
  }
}
.info-card {
  @media only screen and (min-width: 960px) {
    width: 50%;
  }
}
</style>
